var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-wrapper"},[_c('img',{class:_vm.shadow ? 'uk-box-shadow-small' : null,style:(_vm.css),attrs:{"src":_vm.srclink,"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }